<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 15.18 15.18"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          class="cls-1"
          x="3.81"
          y="3.06"
          width="7.56"
          height="9.07"
          transform="translate(-3.14 7.41) rotate(-44.03)"
        />
      </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_28160" data-name="Group 28160">
          <g id="Ellipse_479-2" data-name="Ellipse 479-2">
            <circle class="cls-2" cx="7.59" cy="7.59" r="7.59" />
            <circle class="cls-3" cx="7.59" cy="7.59" r="7.09" />
          </g>
          <g id="Group_28158-3" data-name="Group 28158-3">
            <g class="cls-4">
              <g id="Group_28158-4" data-name="Group 28158-4">
                <path
                  id="Path_16090-2"
                  data-name="Path 16090-2"
                  class="cls-5"
                  d="M6.86,10.3a.29.29,0,0,1,.33-.07,2.23,2.23,0,1,0,.08-4.17l.83.85a.33.33,0,0,1,0,.46.38.38,0,0,1-.17.08l-3.66.6a.33.33,0,0,1-.37-.27.29.29,0,0,1,0-.13l.83-3.52a.32.32,0,0,1,.38-.24A.28.28,0,0,1,5.27,4l.64.66a.32.32,0,0,0,.37.07,3.86,3.86,0,0,1,5.19,1.72,3.69,3.69,0,0,1,.37,1.21,3.78,3.78,0,0,1-1.31,3.42,3.88,3.88,0,0,1-4.35.48A.32.32,0,0,1,6,11.11L6.1,11Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1,
.cls-3 {
  fill: none;
}
.cls-2 {
  fill: #fff;
}
.cls-3 {
  stroke: #0064ff;
}
.cls-4 {
  clip-path: url(#clip-path);
}
.cls-5 {
  fill: #0064ff;
}
</style>
